/* eslint-disable @next/next/no-img-element */
import React from 'react';
import PropTypes from 'prop-types';

import './google-play-button.scss';

const GooglePlayButton = ({ url }) => (
  <a className="google-play-button" target="_blank" href={url} rel="noreferrer">
    <img
      src="//www.nerdwallet.com/cdn/DIT/google-play-button.png"
      alt="Get it on Google Play"
      loading="lazy"
    />
  </a>
);

GooglePlayButton.propTypes = {
  url: PropTypes.string.isRequired,
};

GooglePlayButton.displayName = 'GooglePlayButton';

export default GooglePlayButton;
